/**
 * Market Restriction - Client-side validation
 * 
 * Zusätzliche Sicherheitsebene, um zu verhindern, dass Produkte
 * über die Browser-Konsole oder API-Calls zum Warenkorb hinzugefügt werden.
 */

(function() {
  'use strict';

  // Prüfe ob Produkt market-restricted ist
  function isProductRestricted() {
    const productItem = document.querySelector('product-item[data-is-market-restricted="true"]');
    const mainProduct = document.querySelector('[data-is-market-restricted="true"]');
    return productItem || mainProduct;
  }

  // Intercepte alle Add-to-Cart Formulare
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    // Prüfe ob es ein Produkt-Formular ist
    if (form.matches('[is="product-form"]') || form.matches('.product-item__quick-form')) {
      const productContainer = form.closest('product-item, .product, [data-is-market-restricted]');
      
      if (productContainer && productContainer.dataset.isMarketRestricted === 'true') {
        e.preventDefault();
        e.stopPropagation();
        
        console.warn('🚫 Market Restriction: This product cannot be added to cart in this market.');
        
        // Zeige Hinweis
        showRestrictionNotice(productContainer.dataset.restrictionMessage || 'This product is not available in your market.');
        
        return false;
      }
    }
  }, true); // Use capture phase

  // Intercepte Fetch-Requests zum Cart
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    
    // Prüfe ob es ein Cart-Add Request ist
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('cart/add.js'))) {
      if (isProductRestricted()) {
        console.warn('🚫 Market Restriction: Cart add request blocked.');
        return Promise.reject(new Error('Product is restricted in this market'));
      }
    }
    
    return originalFetch.apply(this, args);
  };

  // Zeige Benachrichtigung
  function showRestrictionNotice(message) {
    // Prüfe ob es bereits eine Benachrichtigung gibt
    let notice = document.querySelector('.market-restriction-notice');
    
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'market-restriction-notice';
      notice.style.cssText = `
        position: fixed;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        background: #fff3cd;
        border: 2px solid #ffc107;
        color: #856404;
        padding: 15px 25px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 10000;
        max-width: 500px;
        text-align: center;
        font-weight: 500;
        animation: slideDown 0.3s ease;
      `;
      
      // Animation
      const style = document.createElement('style');
      style.textContent = `
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
      `;
      document.head.appendChild(style);
      
      document.body.appendChild(notice);
    }
    
    notice.textContent = message;
    notice.style.display = 'block';
    
    // Automatisch ausblenden nach 5 Sekunden
    setTimeout(() => {
      notice.style.opacity = '0';
      notice.style.transition = 'opacity 0.3s ease';
      setTimeout(() => {
        notice.style.display = 'none';
        notice.style.opacity = '1';
      }, 300);
    }, 5000);
  }
})();
